<div fxLayout="column" fxLayoutGap="2rem">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1rem">
    <mat-checkbox [formControl]="formGroup.get('active')">{{ 'core.active' | translate  }}</mat-checkbox>
    <div class="reminder-hint" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
      <mat-icon>info_outline</mat-icon>
      <span>{{ 'reminder.managerHint' | translate }}</span>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="2rem">
    <mat-form-field id="date">
      <mat-label>{{ 'reminder.date' | translate }}</mat-label>
      <input matInput [matDatepickerFilter]="isValidDate" [matDatepicker]="datePicker" [formControl]="formGroup.get('date')"/>
      <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
      <mat-datepicker #datePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'reminder.time' | translate }}</mat-label>
      <input matInput type="time" [formControl]="formGroup.get('time')">
    </mat-form-field>
  </div>

  <mat-form-field>
    <mat-label>{{ 'reminder.text' | translate }}</mat-label>
    <textarea matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="5"
              cdkAutosizeMaxRows="10"
              maxlength="100"
              [formControl]="formGroup.get('text')"
    ></textarea>
  </mat-form-field>
</div>
